

import chessbanner from '../../../media/about/chess/chessbanner.jpeg';
import chessbar from '../../../media/about/chess/chessbar.jpeg';
import chessthinking from '../../../media/about/chess/chessthinking.jpeg';
import young2chess from '../../../media/about/chess/young2chess.jpeg';

const chessStory = {
    id: "chess",
    title: "Chess",
    heroImage: chessbanner,
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    description: "Although I’ve played chess since I was young, I really started focusing on it when my father offered me a deal: I could get my first phone if I beat him three times. That motivation pushed me to learn the game properly, and the interest stuck. I continue to play today and always welcome a good challenge.",
    gallery: [
        { type: 'image', src: chessbar },
        { type: 'image', src: chessthinking },
        { type: 'image', src: young2chess }

    ]
};

export default chessStory;